import { svgLoading } from 'stories/assets'

interface InputProps {
  show: boolean
  message?: string
}

export function LayoutLoading({ show, message }: InputProps) {
  if (!show) return null
  return (
    <div className="absolute left-0 top-0 right-0 bottom-0 bg-white/50 dark:bg-slate-900/50 place-items-center flex z-50">
      <div className="flex flex-col w-full place-items-center gap-2">
        <img src={svgLoading} className="inline w-6 h-6 text-white animate-spin" />
        {message ? <div className="text-sm font-medium text-gray-800 dark:text-gray-100">{message}</div> : null}
      </div>
    </div>
  )
}
